export const syrveTranslations = {
  ru: {
    'syrve.references.title': 'Syrve справочники',
    'syrve.references.subtitle': 'Счета оплаты и статьи ДДС из подключённого Syrve с группировкой по иерархии справочника',
    'syrve.references.refresh': 'Обновить справочники',
    'syrve.references.account': 'Счёт',
    'syrve.references.cashFlowArticle': 'Статья ДДС',
    'syrve.references.accountsEmpty.title': 'Справочник счетов пуст',
    'syrve.references.accountsEmpty.description': 'Подключите интеграцию Syrve и убедитесь, что live-каталог доступен.',
    'syrve.references.articlesEmpty.title': 'Справочник статей ДДС пуст',
    'syrve.references.articlesEmpty.description': 'Подключите интеграцию Syrve и убедитесь, что live-каталог доступен.',
    'syrve.references.fallbackNotice': 'fallback, не live-каталог',
    'syrve.references.summary': 'Подключение {connection}: {accounts} счетов, {articles} статей ДДС',
    'syrve.references.accountsSection': 'План счетов',
    'syrve.references.articlesSection': 'Статьи ДДС',
    'syrve.references.expandAll': 'Развернуть всё',
    'syrve.references.collapseAll': 'Свернуть всё',
    'syrve.references.expandNode': 'Развернуть группу',
    'syrve.references.collapseNode': 'Свернуть группу',
    'syrve.references.search': 'Поиск по коду, имени, типу…',
    'syrve.references.searchAccounts': 'Поиск по плану счетов',
    'syrve.references.searchArticles': 'Поиск по статьям ДДС',
    'syrve.references.accountType': 'Тип счёта',
    'syrve.references.cashFlowType': 'Тип ДДС',
    'syrve.references.searchEmpty.title': 'Ничего не найдено',
    'syrve.references.searchEmpty.description': 'Измените поисковый запрос или сбросьте фильтр.',
    'syrve.paymentReferencePicker.account': 'Счёт оплаты',
    'syrve.paymentReferencePicker.cashFlowArticle': 'Статья ДДС',
    'syrve.paymentReferencePicker.loading': 'Загрузка справочников Syrve…',
    'syrve.paymentReferencePicker.empty': 'Live-справочники недоступны. Проверьте подключение Syrve и runtime.',
    'syrve.paymentReferencePicker.search': 'Поиск…',
    'syrve.paymentReferencePicker.accountHint': 'Выберите счёт в дереве',
    'syrve.paymentReferencePicker.articleHint': 'Выберите статью ДДС в дереве',
    'syrve.connections.title': 'Подключения Syrve',
    'syrve.connections.subtitle': 'Операционный реестр подключений Pay',
    'syrve.connections.hideForm': 'Скрыть форму',
    'syrve.connections.create': 'Создать подключение',
    'syrve.connections.syncDocuments': 'Синхронизировать документы',
    'syrve.connections.new.title': 'Новое подключение',
    'syrve.connections.form.name': 'Название',
    'syrve.connections.form.scope': 'Тип подключения',
    'syrve.connections.form.scopeRms': 'RMS - один ресторан/Outlet',
    'syrve.connections.form.scopeChain': 'CHAIN - сеть/организация',
    'syrve.connections.form.scopeHint': 'RMS — один ресторан, привязан к Outlet. CHAIN — сеть на уровне организации без Outlet.',
    'syrve.connections.form.outlet': 'Outlet',
    'syrve.connections.form.selectOutlet': 'Выберите Outlet',
    'syrve.connections.form.outletHint': 'Можно выбрать здесь или в шапке страницы (Организация / Outlet).',
    'syrve.connections.form.noOutlets': 'В организации нет активных Outlet. Создайте Outlet в настройках организации.',
    'syrve.connections.form.outletsLoadError': 'Не удалось загрузить список Outlet.',
    'syrve.connections.form.baseUrl': 'Адрес сервера',
    'syrve.connections.form.baseUrlHint': 'Можно ввести адрес без /resto и без http/https; система нормализует адрес сама.',
    'syrve.connections.form.login': 'Логин',
    'syrve.connections.form.password': 'Пароль',
    'syrve.connections.form.adminLogin': 'Логин администратора iiko',
    'syrve.connections.form.adminPassword': 'Пароль администратора iiko',
    'syrve.connections.form.provisionServiceAccount': 'Автоматически создать MyHorecaPayUser',
    'syrve.connections.form.provisionServiceAccountHint': 'Администратор используется только для настройки. Pay сгенерирует отдельный пароль и сохранит только SHA1 технической учетной записи.',
    'syrve.connections.probe.success': 'Подключение проверено',
    'syrve.connections.probe.failed': 'Проверка не прошла',
    'syrve.connections.probe.button': 'Проверить подключение',
    'syrve.connections.probe.detectedRms': 'Автоматически определено: RMS',
    'syrve.connections.probe.detectedChain': 'Автоматически определено: CHAIN',
    'syrve.connections.probe.unknownScope': 'Тип подключения не удалось определить автоматически. Выберите RMS или CHAIN вручную.',
    'syrve.connections.probe.overrideHint': 'Тип предложен автоматически. При необходимости выберите другое значение вручную.',
    'syrve.connections.probe.detectedRmsMissingOutlet': 'Сервер определён как RMS (один ресторан). Выберите Outlet в форме ниже или в шапке страницы.',
    'syrve.connections.probe.detectedRmsCreateOutlet': 'Сервер определён как RMS. Создайте Outlet в форме ниже и нажмите «Создать Outlet и выбрать».',
    'syrve.connections.form.createOutletBelow': 'Создайте Outlet ниже — без него RMS-подключение сохранить нельзя.',
    'syrve.connections.form.outletSelectedPendingList': 'Outlet выбран. Можно создавать RMS-подключение.',
    'syrve.connections.submit': 'Создать',
    'syrve.connections.error.rmsContext': 'Для RMS подключения выберите Outlet в форме или в шапке страницы.',
    'syrve.connections.error.create': 'Не удалось создать подключение',
    'syrve.connections.error.probe': 'Не удалось проверить подключение',
    'syrve.connections.column.name': 'Название',
    'syrve.connections.column.scope': 'Scope',
    'syrve.connections.column.login': 'Логин',
    'syrve.connections.column.status': 'Статус',
    'syrve.connections.status.enabled': 'Включено',
    'syrve.connections.status.disabled': 'Отключено',
    'syrve.connections.action.test': 'Проверить',
    'syrve.connections.empty.title': 'Подключения не настроены',
    'syrve.connections.empty.description': 'Создайте подключение для синхронизации накладных.',
    'syrve.connectionDetail.notFound': 'Подключение не найдено',
    'syrve.connectionDetail.test': 'Проверить подключение',
    'syrve.connectionDetail.bridge': 'Создать/обновить bridge',
    'syrve.connectionDetail.syncDocuments': 'Синхронизировать документы',
    'syrve.connectionDetail.syncSuppliers': 'Синхронизировать контрагентов',
    'syrve.connectionDetail.syncSuppliersFull': 'Полная пересинхронизация контрагентов',
    'syrve.sync.refreshData': 'Обновить данные Syrve',
    'syrve.sync.hardDocumentRefreshLink': 'Полностью перечитать unpaid…',
    'syrve.sync.fullResyncLink': 'Полная пересинхронизация каталога…',
    'syrve.sync.inProgress': 'Обновление данных Syrve выполняется…',
    'syrve.sync.inProgressHardDocuments': 'Выполняется полное обновление unpaid документов…',
    'syrve.sync.inProgressFull': 'Полная пересинхронизация выполняется…',
    'syrve.sync.success': 'Данные Syrve обновлены.',
    'syrve.sync.successHardDocuments': 'Полное обновление unpaid документов завершено.',
    'syrve.sync.successFull': 'Полная пересинхронизация каталога запущена.',
    'syrve.sync.error': 'Не удалось обновить данные Syrve.',
    'syrve.sync.hardDocumentRefreshConfirm.title': 'Полностью перечитать unpaid?',
    'syrve.sync.hardDocumentRefreshConfirm.message': 'Для всех исходящих документов будет выполнена точечная проверка unpaid в Syrve без использования свежего локального snapshot. Это создаёт дополнительные RPC и обычно не требуется для обычного обновления.',
    'syrve.sync.hardDocumentRefreshConfirm.confirm': 'Перечитать unpaid',
    'syrve.sync.fullResyncConfirm.title': 'Полная пересинхронизация?',
    'syrve.sync.fullResyncConfirm.message': 'Каталог контрагентов будет загружен заново из Syrve. Отсутствующие в ответе записи будут деактивированы. Обычное обновление дотягивает только изменения.',
    'syrve.sync.fullResyncConfirm.confirm': 'Пересинхронизировать',
    'syrve.connectionDetail.delete': 'Удалить',
    'syrve.connectionDetail.deleteConfirm.title': 'Удалить подключение?',
    'syrve.connectionDetail.deleteConfirm.message': 'Подключение «{name}» будет отключено и скрыто из реестра. Данные Syrve на сервере не изменятся.',
    'syrve.connectionDetail.deleteConfirm.confirm': 'Удалить',
    'syrve.connectionDetail.deleteError': 'Не удалось удалить подключение',
    'syrve.connectionDetail.bridge.linked': 'Связь с Syrve создана',
    'syrve.connectionDetail.check.never': 'Проверка не выполнялась',
    'syrve.connectionDetail.check.neverHelper': 'Запустите проверку подключения перед production-приёмкой.',
    'syrve.connectionDetail.check.connected': 'Подключение работает',
    'syrve.connectionDetail.check.connectedHelper': 'Последняя проверка завершилась успешно.',
    'syrve.connectionDetail.check.attentionHelper': 'Последняя проверка требует внимания оператора.',
    'syrve.connectionDetail.rotation.success': 'Проверка после ротации успешна',
    'syrve.connectionDetail.rotation.attention': 'Проверка после ротации требует внимания',
    'syrve.connectionDetail.rotation.status': 'Статус: {status}',
    'syrve.connectionDetail.rotation.serverVersion': 'Версия сервера: {version}',
    'syrve.connectionDetail.rotation.serverEdition': 'Редакция сервера: {edition}',
    'syrve.connectionDetail.rotation.title': 'Ротация учетных данных',
    'syrve.connectionDetail.rotation.hint': 'Старый пароль не отображается и не подставляется. Адрес сервера остается прежним: {baseUrl}.',
    'syrve.connectionDetail.rotation.newLogin': 'Новый логин',
    'syrve.connectionDetail.rotation.newPassword': 'Новый пароль',
    'syrve.connectionDetail.rotation.adminLogin': 'Логин администратора iiko',
    'syrve.connectionDetail.rotation.adminPassword': 'Пароль администратора iiko',
    'syrve.connectionDetail.rotation.provisionServiceAccount': 'Восстановить MyHorecaPayUser',
    'syrve.connectionDetail.rotation.provisionServiceAccountHint': 'Пароль технической учетной записи будет заменен, а права назначены повторно.',
    'syrve.connectionDetail.rotation.ensureSubmit': 'Восстановить техническую учетную запись',
    'syrve.connectionDetail.rotation.submit': 'Обновить учетные данные',
    'syrve.connectionDetail.rotation.error': 'Не удалось обновить учетные данные Syrve.',
    'syrve.connectionDetail.card.status': 'Статус',
    'syrve.connectionDetail.card.connection': 'Подключение',
    'syrve.connectionDetail.card.diagnostics': 'Диагностика',
    'syrve.connectionDetail.field.state': 'Состояние',
    'syrve.connectionDetail.field.bridge': 'Bridge',
    'syrve.connectionDetail.field.lastCheck': 'Последняя проверка',
    'syrve.connectionDetail.field.name': 'Название',
    'syrve.connectionDetail.field.scope': 'Scope',
    'syrve.connectionDetail.field.scopeChain': 'CHAIN: подключение уровня сети/организации',
    'syrve.connectionDetail.field.scopeRms': 'RMS: подключение к одному Outlet',
    'syrve.connectionDetail.field.baseUrl': 'Адрес сервера',
    'syrve.connectionDetail.field.login': 'Логин',
    'syrve.connectionDetail.field.serverVersion': 'Версия сервера',
    'syrve.connectionDetail.field.serverEdition': 'Редакция сервера',
    'syrve.connectionDetail.diagnostics.show': 'Показать технические детали',
    'syrve.connectionDetail.diagnostics.payConnectionId': 'ID подключения Pay',
    'syrve.connectionDetail.diagnostics.integrationLinkId': 'ID связи интеграции',
    'syrve.connectionDetail.diagnostics.diagnosticCode': 'Диагностический код',
    'syrve.connectionDetail.diagnostics.authMode': 'Режим авторизации',
    'syrve.connectionDetail.diagnostics.sessionTransport': 'Транспорт сессии',
    'syrve.connectionDetail.diagnostics.credentialMode': 'Режим учетных данных',
    'syrve.connectionDetail.diagnostics.runtime': 'Runtime Syrve',
    'syrve.connectionDetail.diagnostics.httpStatus': 'HTTP статус последней проверки',
    'syrve.connectionDetail.diagnostics.iikoErrorCode': 'Код ошибки интеграции',
    'syrve.documents.title': 'Накладные Syrve',
    'syrve.documents.subtitle': 'Локальная копия состояния документов после синхронизации',
    'syrve.documents.tabs.all': 'Все',
    'syrve.documents.tabs.unpaid': 'Не оплачено',
    'syrve.documents.tabs.partiallyPaid': 'Частично оплачено',
    'syrve.documents.tabs.paid': 'Оплачено',
    'syrve.documents.typeTabs.all': 'Все типы',
    'syrve.documents.typeTabs.incoming': 'Приходные',
    'syrve.documents.typeTabs.outgoing': 'Расходные',
    'syrve.documents.type.incoming': 'Приходная',
    'syrve.documents.type.outgoing': 'Расходная',
    'syrve.documents.unpaid.title': 'Не оплачено',
    'syrve.documents.unpaid.subtitle': 'Документы с непогашенной задолженностью',
    'syrve.documents.partiallyPaid.title': 'Частично оплачено',
    'syrve.documents.partiallyPaid.subtitle': 'Документы с частичной оплатой',
    'syrve.documents.paid.title': 'Оплачено',
    'syrve.documents.paid.subtitle': 'Полностью оплаченные документы',
    'syrve.documents.sync': 'Синхронизировать',
    'syrve.documents.column.number': 'Номер',
    'syrve.documents.column.counterparty': 'Контрагент',
    'syrve.documents.column.type': 'Тип',
    'syrve.documents.column.unpaid': 'Не оплачено',
    'syrve.documents.column.balance': 'Расчёты',
    'syrve.documents.balance.outstanding': 'К оплате',
    'syrve.documents.balance.paid': 'Оплачено',
    'syrve.documents.balance.overpaid': 'Переплата',
    'syrve.documents.column.synced': 'Синхр.',
    'syrve.documents.column.processingState': 'Проведение',
    'syrve.documents.processing.processed': 'Проведена',
    'syrve.documents.processing.notProcessed': 'Не проведена',
    'syrve.documents.processing.unknown': 'Статус неизвестен',
    'syrve.documents.processing.deleted': 'Удалена',
    'syrve.documents.empty.title': 'Документы не найдены',
    'syrve.documents.empty.description': 'Запустите синхронизацию или проверьте подключение Syrve.',
    'syrve.documentDetail.notFound': 'Документ не найден',
    'syrve.documentDetail.title': 'Накладная №{number}',
    'syrve.documentDetail.refresh': 'Обновить из Syrve',
    'syrve.documentDetail.readOnlyBadge': 'Только просмотр',
    'syrve.documentDetail.sections.summary': 'Сведения о накладной',
    'syrve.documentDetail.sections.amounts': 'Суммы и оплата',
    'syrve.documentDetail.documentStatus': 'Статус документа',
    'syrve.documentDetail.paymentStatus': 'Статус оплаты',
    'syrve.documentDetail.linesCount': '{count} поз.',
    'syrve.documentDetail.linesCountEmpty': 'Нет позиций',
    'syrve.documentDetail.counterparty': 'Контрагент',
    'syrve.documentDetail.supplier': 'Поставщик',
    'syrve.documentDetail.buyer': 'Покупатель',
    'syrve.documentDetail.documentType': 'Тип документа',
    'syrve.documentDetail.documentNumber': 'Номер',
    'syrve.documentDetail.documentDate': 'Дата',
    'syrve.documentDetail.warehouse': 'Склад',
    'syrve.documentDetail.conception': 'Концепция',
    'syrve.documentDetail.comment': 'Комментарий',
    'syrve.documentDetail.paid': 'Оплачено',
    'syrve.documentDetail.unpaid': 'Не оплачено',
    'syrve.documentDetail.outstanding': 'К оплате',
    'syrve.documentDetail.overpayment': 'Переплата',
    'syrve.documentDetail.lastSync': 'Последняя синхронизация',
    'syrve.documentDetail.linesSyncedAt': 'Позиции синхронизированы',
    'syrve.documentDetail.linesSection': 'Позиции',
    'syrve.documentDetail.payloadHash': 'Payload hash',
    'syrve.documentDetail.tabs.all': 'Все',
    'syrve.documentDetail.tabs.goods': 'Товары',
    'syrve.documentDetail.tabs.goodsHint': 'Фильтр по типам позиций будет расширен; сейчас показаны все строки документа.',
    'syrve.documentDetail.lines.num': '№',
    'syrve.documentDetail.lines.productCode': 'Код товара',
    'syrve.documentDetail.lines.productName': 'Наименование',
    'syrve.documentDetail.lines.productSize': 'Размер',
    'syrve.documentDetail.lines.amountUnit': 'Ед. изм.',
    'syrve.documentDetail.lines.amount': 'Количество',
    'syrve.documentDetail.lines.actualAmount': 'Фактическое',
    'syrve.documentDetail.lines.price': 'Цена за ед.',
    'syrve.documentDetail.lines.sumWithVat': 'Сумма с НДС',
    'syrve.documentDetail.lines.discount': 'Скидка',
    'syrve.documentDetail.lines.ndsPercent': 'НДС, %',
    'syrve.documentDetail.lines.ndsSum': 'НДС сумма',
    'syrve.documentDetail.lines.sumWithoutNds': 'Сумма без НДС',
    'syrve.documentDetail.lines.amountFactor': 'Коэф. списания',
    'syrve.documentDetail.lines.costPrice': 'Себестоимость',
    'syrve.documentDetail.lines.stockBalance': 'Остаток до/после',
    'syrve.documentDetail.lines.customsDeclaration': 'Таможенная декларация',
    'syrve.documentDetail.lines.comment': 'Комментарий',
    'syrve.documentDetail.lines.empty': 'Позиции не загружены. Нажмите «Обновить из Syrve» или выполните sync документов.',
    'syrve.syncRuns.title': 'История синхронизаций',
    'syrve.syncRuns.subtitle': 'SyrveDocumentSyncRun — аудит периодического sync',
    'syrve.syncRuns.column.started': 'Начало',
    'syrve.syncRuns.column.seen': 'Видено',
    'syrve.syncRuns.column.inserted': 'Новых',
    'syrve.syncRuns.column.updated': 'Обновлено',
    'syrve.syncRuns.column.stale': 'Stale',
    'syrve.syncRuns.empty.title': 'Синхронизации ещё не выполнялись',
    'syrve.postings.title': 'Очередь проведения оплат',
    'syrve.postings.subtitle': 'Статус отправки в iiko/Syrve по каждому проведению и следующее действие',
    'syrve.postings.loading': 'Загружаем очередь проведения…',
    'syrve.postings.filterStatus': 'Статус: {status}',
    'syrve.postings.actions.refresh': 'Обновить',
    'syrve.postings.filters.all': 'Все',
    'syrve.postings.filters.approve': 'Ждёт утверждения',
    'syrve.postings.filters.ready': 'В очереди worker',
    'syrve.postings.filters.inProgress': 'Отправляется',
    'syrve.postings.filters.failed': 'Ошибка',
    'syrve.postings.filters.done': 'Завершено',
    'syrve.postings.column.paymentId': 'ID проведения',
    'syrve.postings.column.allocation': 'Распределение',
    'syrve.postings.column.amount': 'Сумма',
    'syrve.postings.column.postingStatus': 'Статус проведения',
    'syrve.postings.column.nextStep': 'Следующий шаг',
    'syrve.postings.column.action': 'Действие',
    'syrve.postings.column.attempts': 'Попытки в iiko',
    'syrve.postings.action.open': 'Открыть',
    'syrve.postings.action.approve': 'Утвердить',
    'syrve.postings.action.retry': 'Повторить',
    'syrve.postings.actionHint.approve': 'Нужно ручное утверждение проведения. После этого worker отправит оплату в iiko.',
    'syrve.postings.actionHint.waitingWorker': 'Утверждено. Worker заберёт в очередь в течение ~30 секунд.',
    'syrve.postings.actionHint.sending': 'Worker сейчас отправляет оплату в iiko.',
    'syrve.postings.actionHint.readback': 'Оплата отправлена. Ждём readback и сверку.',
    'syrve.postings.actionHint.retryScheduled': 'Повтор отправки запланирован автоматически.',
    'syrve.postings.actionHint.failed': 'Отправка не удалась. Можно повторить вручную.',
    'syrve.postings.actionHint.done': 'Проведение завершено и сверено.',
    'syrve.postings.actionHint.posted': 'Оплата проведена в iiko, ожидает финальной сверки.',
    'syrve.postings.actionHint.open': 'Откройте карточку проведения для деталей.',
    'syrve.postings.summary.total': 'Всего проведений',
    'syrve.postings.summary.approve': 'Ждут утверждения',
    'syrve.postings.summary.ready': 'В очереди worker',
    'syrve.postings.summary.done': 'Завершено',
    'syrve.postings.summary.pendingAmount': 'Сумма незавершённых',
    'syrve.postings.empty.title': 'Очередь пуста',
    'syrve.postings.empty.description': 'Нет проведений в выбранном фильтре',
    'syrve.reconciliation.title': 'Reconciliation — ожидает проверки после проведения',
    'syrve.postingDetail.notFound': 'Проведение не найдено',
    'syrve.postingDetail.title': 'Проведение {id}…',
    'syrve.postingDetail.subtitle': 'Allocation {allocationId}',
    'syrve.postingDetail.dryRun': 'Dry-run',
    'syrve.postingDetail.approve': 'Утвердить',
    'syrve.postingDetail.retryWrite': 'Повторить write',
    'syrve.postingDetail.reconcile': 'Сверить',
    'syrve.postingDetail.anomaly.title': 'Критическая аномалия платежа',
    'syrve.postingDetail.anomaly.description': 'Платёж мог быть проведён в Syrve, но сверка не подтверждена. Повторное проведение заблокировано до ручной проверки.',
    'syrve.postingDetail.anomaly.link': 'Аномалия {id}…',
    'syrve.postingDetail.writeBlocked': 'Повторное проведение заблокировано: по документу есть открытая критическая аномалия.',
    'syrve.postingDetail.operationFailed': 'Операция не выполнена. Обновите проведение: статус или rowVersion могли измениться.',
    'syrve.postingDetail.postedNotReconciled': 'Платёж проведён (PASS_WRITE), но сверка ещё не подтверждена (Not PASS_RECONCILE).',
    'syrve.postingDetail.reconciled': 'PASS_WRITE + PASS_RECONCILE',
    'syrve.postingDetail.preflight.title': 'Method-specific preflight',
    'syrve.postingDetail.preflight.eligible': 'Eligible',
    'syrve.postingDetail.preflight.notEligible': 'Not eligible',
    'syrve.postingDetail.writeTarget.title': 'Write target and gates',
    'syrve.postingDetail.writeTarget.account': 'Account',
    'syrve.postingDetail.writeTarget.cashFlowArticle': 'Cash-flow article',
    'syrve.postingDetail.writeTarget.idempotencyKey': 'Idempotency key',
    'syrve.postingDetail.writeTarget.requestHash': 'Request hash',
    'syrve.postingDetail.writeTarget.attemptCount': 'Attempt count',
    'syrve.postingDetail.writeTarget.reconciliationAttempts': 'Reconciliation attempts',
    'syrve.postingDetail.writeTarget.nextRetry': 'Next retry',
    'syrve.postingDetail.writeTarget.nextReconciliation': 'Next reconciliation',
    'syrve.postingDetail.writeTarget.openAnomaly': 'Open anomaly',
    'syrve.postingDetail.writeTarget.rowVersion': 'RowVersion',
    'syrve.postingDetail.writeTarget.accountId': 'Account ID',
    'syrve.postingDetail.writeTarget.accountName': 'Account name',
    'syrve.postingDetail.writeTarget.cashFlowArticleId': 'Cash-flow article ID',
    'syrve.postingDetail.writeTarget.cashFlowArticleName': 'Cash-flow article name',
    'syrve.postingDetail.writeTarget.save': 'Сохранить write target',
    'syrve.postingDetail.dryRun.title': 'Dry-run',
    'syrve.postingDetail.dryRun.allowed': 'Разрешено (preview)',
    'syrve.postingDetail.dryRun.blocked': 'Заблокировано: {reason}',
    'syrve.postingDetail.dryRun.unknown': 'unknown',
    'syrve.postingDetail.attempts.title': 'Worker attempts',
    'syrve.postingDetail.attempts.column.time': 'Время',
    'syrve.postingDetail.attempts.column.reason': 'Причина',
    'syrve.postingDetail.attempts.empty.title': 'Попыток worker ещё нет',
    'syrve.postingDetail.attempts.empty.description': 'После queue/approve попытки появятся здесь.',
    'syrve.postingDetail.evidence.title': 'Отчёт сверки',
    'syrve.postingDetail.evidence.writeStatus': 'Статус write',
    'syrve.postingDetail.evidence.writeDiagnostic': 'Write diagnostic',
    'syrve.postingDetail.evidence.writeMessage': 'Write message',
    'syrve.postingDetail.evidence.reconciliationStatus': 'Статус reconciliation',
    'syrve.postingDetail.evidence.reconciliationDiagnostic': 'Reconciliation diagnostic',
    'syrve.postingDetail.evidence.reconciliationMessage': 'Reconciliation message',
    'syrve.postingDetail.evidence.expected.title': 'Ожидаемое состояние (локальный расчёт)',
    'syrve.postingDetail.evidence.expected.item': '{status}, unpaid {amount} (локальный расчёт)',
    'syrve.postingDetail.evidence.live.title': 'Фактическое состояние Syrve (live readback)',
    'syrve.postingDetail.evidence.live.source': 'Source',
    'syrve.postingDetail.evidence.live.item': '{status}, unpaid {amount}',
    'syrve.postingDetail.evidence.live.pending': 'Live readback ещё не выполнен',
  },
  en: {
    'syrve.references.title': 'Syrve references',
    'syrve.references.subtitle': 'Payment accounts and cash-flow articles from the connected Syrve catalog, grouped by hierarchy',
    'syrve.references.refresh': 'Refresh references',
    'syrve.references.account': 'Account',
    'syrve.references.cashFlowArticle': 'Cash-flow article',
    'syrve.references.accountsEmpty.title': 'Account catalog is empty',
    'syrve.references.accountsEmpty.description': 'Connect Syrve integration and ensure the live catalog is available.',
    'syrve.references.articlesEmpty.title': 'Cash-flow catalog is empty',
    'syrve.references.articlesEmpty.description': 'Connect Syrve integration and ensure the live catalog is available.',
    'syrve.references.fallbackNotice': 'fallback, not live catalog',
    'syrve.references.summary': 'Connection {connection}: {accounts} accounts, {articles} cash-flow articles',
    'syrve.references.accountsSection': 'Chart of accounts',
    'syrve.references.articlesSection': 'Cash-flow articles',
    'syrve.references.expandAll': 'Expand all',
    'syrve.references.collapseAll': 'Collapse all',
    'syrve.references.expandNode': 'Expand group',
    'syrve.references.collapseNode': 'Collapse group',
    'syrve.references.search': 'Search by code, name, type…',
    'syrve.references.searchAccounts': 'Search chart of accounts',
    'syrve.references.searchArticles': 'Search cash-flow articles',
    'syrve.references.accountType': 'Account type',
    'syrve.references.cashFlowType': 'Cash-flow type',
    'syrve.references.searchEmpty.title': 'No matches',
    'syrve.references.searchEmpty.description': 'Change the search query or clear the filter.',
    'syrve.paymentReferencePicker.account': 'Payment account',
    'syrve.paymentReferencePicker.cashFlowArticle': 'Cash-flow article',
    'syrve.paymentReferencePicker.loading': 'Loading Syrve reference catalogs…',
    'syrve.paymentReferencePicker.empty': 'Live reference catalogs are unavailable. Check the Syrve connection and runtime.',
    'syrve.paymentReferencePicker.search': 'Search…',
    'syrve.paymentReferencePicker.accountHint': 'Select an account in the tree',
    'syrve.paymentReferencePicker.articleHint': 'Select a cash-flow article in the tree',
    'syrve.connections.title': 'Syrve connections',
    'syrve.connections.subtitle': 'Operational Pay connection registry',
    'syrve.connections.hideForm': 'Hide form',
    'syrve.connections.create': 'Create connection',
    'syrve.connections.syncDocuments': 'Sync documents',
    'syrve.connections.new.title': 'New connection',
    'syrve.connections.form.name': 'Name',
    'syrve.connections.form.scope': 'Connection type',
    'syrve.connections.form.scopeRms': 'RMS — single restaurant/Outlet',
    'syrve.connections.form.scopeChain': 'CHAIN — chain/organization',
    'syrve.connections.form.scopeHint': 'RMS — single restaurant bound to an Outlet. CHAIN — organization-level without Outlet.',
    'syrve.connections.form.outlet': 'Outlet',
    'syrve.connections.form.selectOutlet': 'Select Outlet',
    'syrve.connections.form.outletHint': 'Select here or in the page header (Organization / Outlet).',
    'syrve.connections.form.noOutlets': 'No active Outlets in this organization. Create one in organization settings.',
    'syrve.connections.form.outletsLoadError': 'Failed to load Outlets.',
    'syrve.connections.form.baseUrl': 'Server address',
    'syrve.connections.form.baseUrlHint': 'You can enter the address without /resto and without http/https; the system normalizes it.',
    'syrve.connections.form.login': 'Login',
    'syrve.connections.form.password': 'Password',
    'syrve.connections.form.adminLogin': 'iiko administrator login',
    'syrve.connections.form.adminPassword': 'iiko administrator password',
    'syrve.connections.form.provisionServiceAccount': 'Create MyHorecaPayUser automatically',
    'syrve.connections.form.provisionServiceAccountHint': 'Administrator credentials are used only for setup. Pay generates a separate password and stores only the service account SHA1.',
    'syrve.connections.probe.success': 'Connection verified',
    'syrve.connections.probe.failed': 'Verification failed',
    'syrve.connections.probe.button': 'Test connection',
    'syrve.connections.probe.detectedRms': 'Automatically detected: RMS',
    'syrve.connections.probe.detectedChain': 'Automatically detected: CHAIN',
    'syrve.connections.probe.unknownScope': 'Connection type was not detected automatically. Choose RMS or CHAIN manually.',
    'syrve.connections.probe.overrideHint': 'The type was suggested automatically. Choose another value manually if needed.',
    'syrve.connections.probe.detectedRmsMissingOutlet': 'Server detected as RMS (single restaurant). Select an Outlet in the form below or in the page header.',
    'syrve.connections.probe.detectedRmsCreateOutlet': 'Server detected as RMS. Create an outlet below and click “Create outlet and select”.',
    'syrve.connections.form.createOutletBelow': 'Create an outlet below — RMS connections cannot be saved without one.',
    'syrve.connections.form.outletSelectedPendingList': 'Outlet selected. You can create the RMS connection.',
    'syrve.connections.submit': 'Create',
    'syrve.connections.error.rmsContext': 'For an RMS connection, select an Outlet in the form or page header.',
    'syrve.connections.error.create': 'Failed to create connection',
    'syrve.connections.error.probe': 'Failed to test connection',
    'syrve.connections.column.name': 'Name',
    'syrve.connections.column.scope': 'Scope',
    'syrve.connections.column.login': 'Login',
    'syrve.connections.column.status': 'Status',
    'syrve.connections.status.enabled': 'Enabled',
    'syrve.connections.status.disabled': 'Disabled',
    'syrve.connections.action.test': 'Test',
    'syrve.connections.empty.title': 'No connections configured',
    'syrve.connections.empty.description': 'Create a connection to sync documents.',
    'syrve.connectionDetail.notFound': 'Connection not found',
    'syrve.connectionDetail.test': 'Test connection',
    'syrve.connectionDetail.bridge': 'Create/update bridge',
    'syrve.connectionDetail.syncDocuments': 'Sync documents',
    'syrve.connectionDetail.syncSuppliers': 'Sync counterparties',
    'syrve.connectionDetail.syncSuppliersFull': 'Full counterparty resync',
    'syrve.sync.refreshData': 'Refresh Syrve data',
    'syrve.sync.hardDocumentRefreshLink': 'Fully refresh unpaid…',
    'syrve.sync.fullResyncLink': 'Full catalog resync…',
    'syrve.sync.inProgress': 'Refreshing Syrve data…',
    'syrve.sync.inProgressHardDocuments': 'Fully refreshing unpaid documents…',
    'syrve.sync.inProgressFull': 'Full resync in progress…',
    'syrve.sync.success': 'Syrve data refreshed.',
    'syrve.sync.successHardDocuments': 'Full unpaid document refresh completed.',
    'syrve.sync.successFull': 'Full catalog resync started.',
    'syrve.sync.error': 'Failed to refresh Syrve data.',
    'syrve.sync.hardDocumentRefreshConfirm.title': 'Fully refresh unpaid?',
    'syrve.sync.hardDocumentRefreshConfirm.message': 'Every outgoing document will perform an exact unpaid read from Syrve instead of reusing a fresh local snapshot. This adds RPC calls and is normally unnecessary for regular refreshes.',
    'syrve.sync.hardDocumentRefreshConfirm.confirm': 'Refresh unpaid',
    'syrve.sync.fullResyncConfirm.title': 'Full resync?',
    'syrve.sync.fullResyncConfirm.message': 'The counterparty catalog will be reloaded from Syrve. Entries missing from the response will be deactivated. Regular refresh only pulls incremental changes.',
    'syrve.sync.fullResyncConfirm.confirm': 'Resync',
    'syrve.connectionDetail.delete': 'Delete',
    'syrve.connectionDetail.deleteConfirm.title': 'Delete connection?',
    'syrve.connectionDetail.deleteConfirm.message': 'Connection "{name}" will be disabled and hidden from the registry. Syrve server data will not change.',
    'syrve.connectionDetail.deleteConfirm.confirm': 'Delete',
    'syrve.connectionDetail.deleteError': 'Failed to delete connection',
    'syrve.connectionDetail.bridge.linked': 'Syrve link created',
    'syrve.connectionDetail.check.never': 'No check performed',
    'syrve.connectionDetail.check.neverHelper': 'Run a connection test before production acceptance.',
    'syrve.connectionDetail.check.connected': 'Connection is working',
    'syrve.connectionDetail.check.connectedHelper': 'Last check completed successfully.',
    'syrve.connectionDetail.check.attentionHelper': 'Last check requires operator attention.',
    'syrve.connectionDetail.rotation.success': 'Post-rotation check succeeded',
    'syrve.connectionDetail.rotation.attention': 'Post-rotation check needs attention',
    'syrve.connectionDetail.rotation.status': 'Status: {status}',
    'syrve.connectionDetail.rotation.serverVersion': 'Server version: {version}',
    'syrve.connectionDetail.rotation.serverEdition': 'Server edition: {edition}',
    'syrve.connectionDetail.rotation.title': 'Credential rotation',
    'syrve.connectionDetail.rotation.hint': 'Old password is not shown or prefilled. Server address remains: {baseUrl}.',
    'syrve.connectionDetail.rotation.newLogin': 'New login',
    'syrve.connectionDetail.rotation.newPassword': 'New password',
    'syrve.connectionDetail.rotation.adminLogin': 'iiko administrator login',
    'syrve.connectionDetail.rotation.adminPassword': 'iiko administrator password',
    'syrve.connectionDetail.rotation.provisionServiceAccount': 'Restore MyHorecaPayUser',
    'syrve.connectionDetail.rotation.provisionServiceAccountHint': 'The service account password will be replaced and all permissions will be applied again.',
    'syrve.connectionDetail.rotation.ensureSubmit': 'Restore service account',
    'syrve.connectionDetail.rotation.submit': 'Update credentials',
    'syrve.connectionDetail.rotation.error': 'Failed to update Syrve credentials.',
    'syrve.connectionDetail.card.status': 'Status',
    'syrve.connectionDetail.card.connection': 'Connection',
    'syrve.connectionDetail.card.diagnostics': 'Diagnostics',
    'syrve.connectionDetail.field.state': 'State',
    'syrve.connectionDetail.field.bridge': 'Bridge',
    'syrve.connectionDetail.field.lastCheck': 'Last check',
    'syrve.connectionDetail.field.name': 'Name',
    'syrve.connectionDetail.field.scope': 'Scope',
    'syrve.connectionDetail.field.scopeChain': 'CHAIN: chain/organization level connection',
    'syrve.connectionDetail.field.scopeRms': 'RMS: single Outlet connection',
    'syrve.connectionDetail.field.baseUrl': 'Server address',
    'syrve.connectionDetail.field.login': 'Login',
    'syrve.connectionDetail.field.serverVersion': 'Server version',
    'syrve.connectionDetail.field.serverEdition': 'Server edition',
    'syrve.connectionDetail.diagnostics.show': 'Show technical details',
    'syrve.connectionDetail.diagnostics.payConnectionId': 'Pay connection ID',
    'syrve.connectionDetail.diagnostics.integrationLinkId': 'Integration link ID',
    'syrve.connectionDetail.diagnostics.diagnosticCode': 'Diagnostic code',
    'syrve.connectionDetail.diagnostics.authMode': 'Auth mode',
    'syrve.connectionDetail.diagnostics.sessionTransport': 'Session transport',
    'syrve.connectionDetail.diagnostics.credentialMode': 'Credential mode',
    'syrve.connectionDetail.diagnostics.runtime': 'Syrve runtime',
    'syrve.connectionDetail.diagnostics.httpStatus': 'Last check HTTP status',
    'syrve.connectionDetail.diagnostics.iikoErrorCode': 'Integration error code',
    'syrve.documents.title': 'Syrve documents',
    'syrve.documents.subtitle': 'Local copy of document state after sync',
    'syrve.documents.tabs.all': 'All',
    'syrve.documents.tabs.unpaid': 'Unpaid',
    'syrve.documents.tabs.partiallyPaid': 'Partially paid',
    'syrve.documents.tabs.paid': 'Paid',
    'syrve.documents.typeTabs.all': 'All types',
    'syrve.documents.typeTabs.incoming': 'Incoming',
    'syrve.documents.typeTabs.outgoing': 'Outgoing',
    'syrve.documents.type.incoming': 'Incoming',
    'syrve.documents.type.outgoing': 'Outgoing',
    'syrve.documents.unpaid.title': 'Unpaid',
    'syrve.documents.unpaid.subtitle': 'Documents with outstanding balance',
    'syrve.documents.partiallyPaid.title': 'Partially paid',
    'syrve.documents.partiallyPaid.subtitle': 'Documents with partial payment',
    'syrve.documents.paid.title': 'Paid',
    'syrve.documents.paid.subtitle': 'Fully paid documents',
    'syrve.documents.sync': 'Sync',
    'syrve.documents.column.number': 'Number',
    'syrve.documents.column.counterparty': 'Counterparty',
    'syrve.documents.column.type': 'Type',
    'syrve.documents.column.unpaid': 'Unpaid',
    'syrve.documents.column.balance': 'Balance',
    'syrve.documents.balance.outstanding': 'To pay',
    'syrve.documents.balance.paid': 'Paid',
    'syrve.documents.balance.overpaid': 'Overpayment',
    'syrve.documents.column.synced': 'Synced',
    'syrve.documents.column.processingState': 'Processing',
    'syrve.documents.processing.processed': 'Processed',
    'syrve.documents.processing.notProcessed': 'Not processed',
    'syrve.documents.processing.unknown': 'Status unknown',
    'syrve.documents.processing.deleted': 'Deleted',
    'syrve.documents.empty.title': 'No documents found',
    'syrve.documents.empty.description': 'Run sync or check the Syrve connection.',
    'syrve.documentDetail.notFound': 'Document not found',
    'syrve.documentDetail.title': 'Invoice #{number}',
    'syrve.documentDetail.refresh': 'Refresh from Syrve',
    'syrve.documentDetail.readOnlyBadge': 'Read only',
    'syrve.documentDetail.sections.summary': 'Invoice summary',
    'syrve.documentDetail.sections.amounts': 'Amounts and payment',
    'syrve.documentDetail.documentStatus': 'Document status',
    'syrve.documentDetail.paymentStatus': 'Payment status',
    'syrve.documentDetail.linesCount': '{count} lines',
    'syrve.documentDetail.linesCountEmpty': 'No lines',
    'syrve.documentDetail.counterparty': 'Counterparty',
    'syrve.documentDetail.supplier': 'Supplier',
    'syrve.documentDetail.buyer': 'Buyer',
    'syrve.documentDetail.documentType': 'Document type',
    'syrve.documentDetail.documentNumber': 'Number',
    'syrve.documentDetail.documentDate': 'Date',
    'syrve.documentDetail.warehouse': 'Warehouse',
    'syrve.documentDetail.conception': 'Concept',
    'syrve.documentDetail.comment': 'Comment',
    'syrve.documentDetail.paid': 'Paid',
    'syrve.documentDetail.unpaid': 'Unpaid',
    'syrve.documentDetail.outstanding': 'To pay',
    'syrve.documentDetail.overpayment': 'Overpayment',
    'syrve.documentDetail.lastSync': 'Last sync',
    'syrve.documentDetail.linesSyncedAt': 'Lines synced at',
    'syrve.documentDetail.linesSection': 'Line items',
    'syrve.documentDetail.payloadHash': 'Payload hash',
    'syrve.documentDetail.tabs.all': 'All',
    'syrve.documentDetail.tabs.goods': 'Goods',
    'syrve.documentDetail.tabs.goodsHint': 'Item-type filters will be expanded later; all document lines are shown for now.',
    'syrve.documentDetail.lines.num': '#',
    'syrve.documentDetail.lines.productCode': 'Product code',
    'syrve.documentDetail.lines.productName': 'Name',
    'syrve.documentDetail.lines.productSize': 'Size',
    'syrve.documentDetail.lines.amountUnit': 'Unit',
    'syrve.documentDetail.lines.amount': 'Qty',
    'syrve.documentDetail.lines.actualAmount': 'Actual qty',
    'syrve.documentDetail.lines.price': 'Unit price',
    'syrve.documentDetail.lines.sumWithVat': 'Sum with VAT',
    'syrve.documentDetail.lines.discount': 'Discount',
    'syrve.documentDetail.lines.ndsPercent': 'VAT %',
    'syrve.documentDetail.lines.ndsSum': 'VAT amount',
    'syrve.documentDetail.lines.sumWithoutNds': 'Sum excl. VAT',
    'syrve.documentDetail.lines.amountFactor': 'Write-off coef.',
    'syrve.documentDetail.lines.costPrice': 'Cost price',
    'syrve.documentDetail.lines.stockBalance': 'Stock before/after',
    'syrve.documentDetail.lines.customsDeclaration': 'Customs declaration',
    'syrve.documentDetail.lines.comment': 'Comment',
    'syrve.documentDetail.lines.empty': 'No line items loaded. Click Refresh from Syrve or run document sync.',
    'syrve.syncRuns.title': 'Sync history',
    'syrve.syncRuns.subtitle': 'SyrveDocumentSyncRun — periodic sync audit',
    'syrve.syncRuns.column.started': 'Started',
    'syrve.syncRuns.column.seen': 'Seen',
    'syrve.syncRuns.column.inserted': 'Inserted',
    'syrve.syncRuns.column.updated': 'Updated',
    'syrve.syncRuns.column.stale': 'Stale',
    'syrve.syncRuns.empty.title': 'No sync runs yet',
    'syrve.postings.title': 'Payment posting queue',
    'syrve.postings.subtitle': 'iiko/Syrve send status for each posting and the next required action',
    'syrve.postings.loading': 'Loading posting queue…',
    'syrve.postings.filterStatus': 'Status: {status}',
    'syrve.postings.actions.refresh': 'Refresh',
    'syrve.postings.filters.all': 'All',
    'syrve.postings.filters.approve': 'Awaiting approval',
    'syrve.postings.filters.ready': 'Worker queue',
    'syrve.postings.filters.inProgress': 'Sending',
    'syrve.postings.filters.failed': 'Failed',
    'syrve.postings.filters.done': 'Completed',
    'syrve.postings.column.paymentId': 'Posting ID',
    'syrve.postings.column.allocation': 'Allocation',
    'syrve.postings.column.amount': 'Amount',
    'syrve.postings.column.postingStatus': 'Posting status',
    'syrve.postings.column.nextStep': 'Next step',
    'syrve.postings.column.action': 'Action',
    'syrve.postings.column.attempts': 'iiko attempts',
    'syrve.postings.action.open': 'Open',
    'syrve.postings.action.approve': 'Approve',
    'syrve.postings.action.retry': 'Retry',
    'syrve.postings.actionHint.approve': 'Manual posting approval is required. After that the worker sends the payment to iiko.',
    'syrve.postings.actionHint.waitingWorker': 'Approved. The worker will pick it up within ~30 seconds.',
    'syrve.postings.actionHint.sending': 'The worker is sending the payment to iiko now.',
    'syrve.postings.actionHint.readback': 'Payment was sent. Waiting for readback and reconciliation.',
    'syrve.postings.actionHint.retryScheduled': 'A retry is scheduled automatically.',
    'syrve.postings.actionHint.failed': 'Send failed. You can retry manually.',
    'syrve.postings.actionHint.done': 'Posting is completed and reconciled.',
    'syrve.postings.actionHint.posted': 'Payment was posted in iiko and awaits final reconciliation.',
    'syrve.postings.actionHint.open': 'Open the posting card for details.',
    'syrve.postings.summary.total': 'Total postings',
    'syrve.postings.summary.approve': 'Awaiting approval',
    'syrve.postings.summary.ready': 'Worker queue',
    'syrve.postings.summary.done': 'Completed',
    'syrve.postings.summary.pendingAmount': 'Pending amount',
    'syrve.postings.empty.title': 'Queue is empty',
    'syrve.postings.empty.description': 'No postings in the selected filter',
    'syrve.reconciliation.title': 'Reconciliation — pending post-posting review',
    'syrve.postingDetail.notFound': 'Posting not found',
    'syrve.postingDetail.title': 'Posting {id}…',
    'syrve.postingDetail.subtitle': 'Allocation {allocationId}',
    'syrve.postingDetail.dryRun': 'Dry-run',
    'syrve.postingDetail.approve': 'Approve',
    'syrve.postingDetail.retryWrite': 'Retry write',
    'syrve.postingDetail.reconcile': 'Reconcile',
    'syrve.postingDetail.anomaly.title': 'Critical payment anomaly',
    'syrve.postingDetail.anomaly.description': 'Payment may have been posted in Syrve, but reconciliation is not confirmed. Re-posting is blocked until manual review.',
    'syrve.postingDetail.anomaly.link': 'Anomaly {id}…',
    'syrve.postingDetail.writeBlocked': 'Re-posting blocked: open critical anomaly on document.',
    'syrve.postingDetail.operationFailed': 'Operation failed. Refresh posting: status or rowVersion may have changed.',
    'syrve.postingDetail.postedNotReconciled': 'Payment posted (PASS_WRITE), but reconciliation not confirmed (Not PASS_RECONCILE).',
    'syrve.postingDetail.reconciled': 'PASS_WRITE + PASS_RECONCILE',
    'syrve.postingDetail.preflight.title': 'Method-specific preflight',
    'syrve.postingDetail.preflight.eligible': 'Eligible',
    'syrve.postingDetail.preflight.notEligible': 'Not eligible',
    'syrve.postingDetail.writeTarget.title': 'Write target and gates',
    'syrve.postingDetail.writeTarget.account': 'Account',
    'syrve.postingDetail.writeTarget.cashFlowArticle': 'Cash-flow article',
    'syrve.postingDetail.writeTarget.idempotencyKey': 'Idempotency key',
    'syrve.postingDetail.writeTarget.requestHash': 'Request hash',
    'syrve.postingDetail.writeTarget.attemptCount': 'Attempt count',
    'syrve.postingDetail.writeTarget.reconciliationAttempts': 'Reconciliation attempts',
    'syrve.postingDetail.writeTarget.nextRetry': 'Next retry',
    'syrve.postingDetail.writeTarget.nextReconciliation': 'Next reconciliation',
    'syrve.postingDetail.writeTarget.openAnomaly': 'Open anomaly',
    'syrve.postingDetail.writeTarget.rowVersion': 'RowVersion',
    'syrve.postingDetail.writeTarget.accountId': 'Account ID',
    'syrve.postingDetail.writeTarget.accountName': 'Account name',
    'syrve.postingDetail.writeTarget.cashFlowArticleId': 'Cash-flow article ID',
    'syrve.postingDetail.writeTarget.cashFlowArticleName': 'Cash-flow article name',
    'syrve.postingDetail.writeTarget.save': 'Save write target',
    'syrve.postingDetail.dryRun.title': 'Dry-run',
    'syrve.postingDetail.dryRun.allowed': 'Allowed (preview)',
    'syrve.postingDetail.dryRun.blocked': 'Blocked: {reason}',
    'syrve.postingDetail.dryRun.unknown': 'unknown',
    'syrve.postingDetail.attempts.title': 'Worker attempts',
    'syrve.postingDetail.attempts.column.time': 'Time',
    'syrve.postingDetail.attempts.column.reason': 'Reason',
    'syrve.postingDetail.attempts.empty.title': 'No worker attempts yet',
    'syrve.postingDetail.attempts.empty.description': 'Attempts appear here after queue/approve.',
    'syrve.postingDetail.evidence.title': 'Reconciliation report',
    'syrve.postingDetail.evidence.writeStatus': 'Write status',
    'syrve.postingDetail.evidence.writeDiagnostic': 'Write diagnostic',
    'syrve.postingDetail.evidence.writeMessage': 'Write message',
    'syrve.postingDetail.evidence.reconciliationStatus': 'Reconciliation status',
    'syrve.postingDetail.evidence.reconciliationDiagnostic': 'Reconciliation diagnostic',
    'syrve.postingDetail.evidence.reconciliationMessage': 'Reconciliation message',
    'syrve.postingDetail.evidence.expected.title': 'Expected state (local calculation)',
    'syrve.postingDetail.evidence.expected.item': '{status}, unpaid {amount} (local calculation)',
    'syrve.postingDetail.evidence.live.title': 'Actual Syrve state (live readback)',
    'syrve.postingDetail.evidence.live.source': 'Source',
    'syrve.postingDetail.evidence.live.item': '{status}, unpaid {amount}',
    'syrve.postingDetail.evidence.live.pending': 'Live readback not performed yet',
  },
  id: {
    'syrve.references.title': 'Referensi Syrve',
    'syrve.references.subtitle': 'Akun pembayaran dan artikel arus kas dari katalog Syrve terhubung, dikelompokkan menurut hierarki',
    'syrve.references.refresh': 'Perbarui referensi',
    'syrve.references.account': 'Akun',
    'syrve.references.cashFlowArticle': 'Artikel arus kas',
    'syrve.references.accountsEmpty.title': 'Katalog akun kosong',
    'syrve.references.accountsEmpty.description': 'Hubungkan integrasi Syrve dan pastikan katalog live tersedia.',
    'syrve.references.articlesEmpty.title': 'Katalog artikel arus kas kosong',
    'syrve.references.articlesEmpty.description': 'Hubungkan integrasi Syrve dan pastikan katalog live tersedia.',
    'syrve.references.fallbackNotice': 'fallback, bukan katalog live',
    'syrve.references.summary': 'Koneksi {connection}: {accounts} akun, {articles} artikel arus kas',
    'syrve.references.accountsSection': 'Bagan akun',
    'syrve.references.articlesSection': 'Artikel arus kas',
    'syrve.references.expandAll': 'Buka semua',
    'syrve.references.collapseAll': 'Tutup semua',
    'syrve.references.expandNode': 'Buka grup',
    'syrve.references.collapseNode': 'Tutup grup',
    'syrve.references.search': 'Cari kode, nama, tipe…',
    'syrve.references.searchAccounts': 'Cari bagan akun',
    'syrve.references.searchArticles': 'Cari artikel arus kas',
    'syrve.references.accountType': 'Tipe akun',
    'syrve.references.cashFlowType': 'Tipe arus kas',
    'syrve.references.searchEmpty.title': 'Tidak ada hasil',
    'syrve.references.searchEmpty.description': 'Ubah kata pencarian atau hapus filter.',
    'syrve.paymentReferencePicker.account': 'Akun pembayaran',
    'syrve.paymentReferencePicker.cashFlowArticle': 'Artikel arus kas',
    'syrve.paymentReferencePicker.loading': 'Memuat katalog referensi Syrve…',
    'syrve.paymentReferencePicker.empty': 'Katalog referensi live tidak tersedia. Periksa koneksi Syrve dan runtime.',
    'syrve.paymentReferencePicker.search': 'Cari…',
    'syrve.paymentReferencePicker.accountHint': 'Pilih akun di pohon',
    'syrve.paymentReferencePicker.articleHint': 'Pilih artikel arus kas di pohon',
    'syrve.connections.title': 'Koneksi Syrve',
    'syrve.connections.subtitle': 'Registri koneksi operasional Pay',
    'syrve.connections.hideForm': 'Sembunyikan formulir',
    'syrve.connections.create': 'Buat koneksi',
    'syrve.connections.syncDocuments': 'Sinkronkan dokumen',
    'syrve.connections.new.title': 'Koneksi baru',
    'syrve.connections.form.name': 'Nama',
    'syrve.connections.form.scope': 'Tipe koneksi',
    'syrve.connections.form.scopeRms': 'RMS — satu restoran/Outlet',
    'syrve.connections.form.scopeChain': 'CHAIN — jaringan/organisasi',
    'syrve.connections.form.scopeHint': 'RMS — satu restoran terikat ke Outlet. CHAIN — level organisasi tanpa Outlet.',
    'syrve.connections.form.outlet': 'Outlet',
    'syrve.connections.form.selectOutlet': 'Pilih Outlet',
    'syrve.connections.form.outletHint': 'Pilih di sini atau di header halaman (Organization / Outlet).',
    'syrve.connections.form.noOutlets': 'Tidak ada Outlet aktif di organisasi ini. Buat di pengaturan organisasi.',
    'syrve.connections.form.outletsLoadError': 'Gagal memuat daftar Outlet.',
    'syrve.connections.form.baseUrl': 'Alamat server',
    'syrve.connections.form.baseUrlHint': 'Alamat bisa tanpa /resto dan tanpa http/https; sistem menormalisasi sendiri.',
    'syrve.connections.form.login': 'Login',
    'syrve.connections.form.password': 'Password',
    'syrve.connections.form.adminLogin': 'Login administrator iiko',
    'syrve.connections.form.adminPassword': 'Password administrator iiko',
    'syrve.connections.form.provisionServiceAccount': 'Buat MyHorecaPayUser secara otomatis',
    'syrve.connections.form.provisionServiceAccountHint': 'Kredensial administrator hanya digunakan untuk pengaturan. Pay membuat password terpisah dan hanya menyimpan SHA1 akun layanan.',
    'syrve.connections.probe.success': 'Koneksi terverifikasi',
    'syrve.connections.probe.failed': 'Verifikasi gagal',
    'syrve.connections.probe.button': 'Uji koneksi',
    'syrve.connections.probe.detectedRms': 'Terdeteksi otomatis: RMS',
    'syrve.connections.probe.detectedChain': 'Terdeteksi otomatis: CHAIN',
    'syrve.connections.probe.unknownScope': 'Tipe koneksi tidak terdeteksi otomatis. Pilih RMS atau CHAIN secara manual.',
    'syrve.connections.probe.overrideHint': 'Tipe disarankan otomatis. Pilih nilai lain secara manual jika diperlukan.',
    'syrve.connections.probe.detectedRmsMissingOutlet': 'Server terdeteksi sebagai RMS (satu restoran). Pilih Outlet di formulir atau header halaman.',
    'syrve.connections.probe.detectedRmsCreateOutlet': 'Server terdeteksi sebagai RMS. Buat outlet di bawah dan klik “Buat outlet dan pilih”.',
    'syrve.connections.form.createOutletBelow': 'Buat outlet di bawah — koneksi RMS tidak dapat disimpan tanpa outlet.',
    'syrve.connections.form.outletSelectedPendingList': 'Outlet dipilih. Anda dapat membuat koneksi RMS.',
    'syrve.connections.submit': 'Buat',
    'syrve.connections.error.rmsContext': 'Untuk koneksi RMS, pilih Outlet di formulir atau header halaman.',
    'syrve.connections.error.create': 'Gagal membuat koneksi',
    'syrve.connections.error.probe': 'Gagal menguji koneksi',
    'syrve.connections.column.name': 'Nama',
    'syrve.connections.column.scope': 'Scope',
    'syrve.connections.column.login': 'Login',
    'syrve.connections.column.status': 'Status',
    'syrve.connections.status.enabled': 'Aktif',
    'syrve.connections.status.disabled': 'Nonaktif',
    'syrve.connections.action.test': 'Uji',
    'syrve.connections.empty.title': 'Koneksi belum dikonfigurasi',
    'syrve.connections.empty.description': 'Buat koneksi untuk sinkronisasi dokumen.',
    'syrve.connectionDetail.notFound': 'Koneksi tidak ditemukan',
    'syrve.connectionDetail.test': 'Uji koneksi',
    'syrve.connectionDetail.bridge': 'Buat/perbarui bridge',
    'syrve.connectionDetail.syncDocuments': 'Sinkronkan dokumen',
    'syrve.connectionDetail.syncSuppliers': 'Sinkronkan counterparty',
    'syrve.connectionDetail.syncSuppliersFull': 'Resync counterparty penuh',
    'syrve.sync.refreshData': 'Perbarui data Syrve',
    'syrve.sync.hardDocumentRefreshLink': 'Perbarui unpaid sepenuhnya…',
    'syrve.sync.fullResyncLink': 'Resync katalog penuh…',
    'syrve.sync.inProgress': 'Memperbarui data Syrve…',
    'syrve.sync.inProgressHardDocuments': 'Memperbarui dokumen unpaid sepenuhnya…',
    'syrve.sync.inProgressFull': 'Resync penuh berjalan…',
    'syrve.sync.success': 'Data Syrve diperbarui.',
    'syrve.sync.successHardDocuments': 'Pembaruan penuh dokumen unpaid selesai.',
    'syrve.sync.successFull': 'Resync katalog penuh dimulai.',
    'syrve.sync.error': 'Gagal memperbarui data Syrve.',
    'syrve.sync.hardDocumentRefreshConfirm.title': 'Perbarui unpaid sepenuhnya?',
    'syrve.sync.hardDocumentRefreshConfirm.message': 'Setiap dokumen outgoing akan membaca unpaid secara tepat dari Syrve tanpa menggunakan snapshot lokal yang masih baru. Ini menambah panggilan RPC dan biasanya tidak diperlukan untuk pembaruan biasa.',
    'syrve.sync.hardDocumentRefreshConfirm.confirm': 'Perbarui unpaid',
    'syrve.sync.fullResyncConfirm.title': 'Resync penuh?',
    'syrve.sync.fullResyncConfirm.message': 'Katalog counterparty akan dimuat ulang dari Syrve. Entri yang tidak ada di respons akan dinonaktifkan. Pembaruan biasa hanya menarik perubahan incremental.',
    'syrve.sync.fullResyncConfirm.confirm': 'Resync',
    'syrve.connectionDetail.delete': 'Hapus',
    'syrve.connectionDetail.deleteConfirm.title': 'Hapus koneksi?',
    'syrve.connectionDetail.deleteConfirm.message': 'Koneksi "{name}" akan dinonaktifkan dan disembunyikan dari registri. Data Syrve di server tidak berubah.',
    'syrve.connectionDetail.deleteConfirm.confirm': 'Hapus',
    'syrve.connectionDetail.deleteError': 'Gagal menghapus koneksi',
    'syrve.connectionDetail.bridge.linked': 'Tautan Syrve dibuat',
    'syrve.connectionDetail.check.never': 'Belum ada pemeriksaan',
    'syrve.connectionDetail.check.neverHelper': 'Jalankan uji koneksi sebelum penerimaan production.',
    'syrve.connectionDetail.check.connected': 'Koneksi berfungsi',
    'syrve.connectionDetail.check.connectedHelper': 'Pemeriksaan terakhir berhasil.',
    'syrve.connectionDetail.check.attentionHelper': 'Pemeriksaan terakhir memerlukan perhatian operator.',
    'syrve.connectionDetail.rotation.success': 'Pemeriksaan pasca rotasi berhasil',
    'syrve.connectionDetail.rotation.attention': 'Pemeriksaan pasca rotasi perlu perhatian',
    'syrve.connectionDetail.rotation.status': 'Status: {status}',
    'syrve.connectionDetail.rotation.serverVersion': 'Versi server: {version}',
    'syrve.connectionDetail.rotation.serverEdition': 'Edisi server: {edition}',
    'syrve.connectionDetail.rotation.title': 'Rotasi kredensial',
    'syrve.connectionDetail.rotation.hint': 'Password lama tidak ditampilkan atau diisi otomatis. Alamat server tetap: {baseUrl}.',
    'syrve.connectionDetail.rotation.newLogin': 'Login baru',
    'syrve.connectionDetail.rotation.newPassword': 'Password baru',
    'syrve.connectionDetail.rotation.adminLogin': 'Login administrator iiko',
    'syrve.connectionDetail.rotation.adminPassword': 'Password administrator iiko',
    'syrve.connectionDetail.rotation.provisionServiceAccount': 'Pulihkan MyHorecaPayUser',
    'syrve.connectionDetail.rotation.provisionServiceAccountHint': 'Password akun layanan akan diganti dan semua izin diterapkan kembali.',
    'syrve.connectionDetail.rotation.ensureSubmit': 'Pulihkan akun layanan',
    'syrve.connectionDetail.rotation.submit': 'Perbarui kredensial',
    'syrve.connectionDetail.rotation.error': 'Gagal memperbarui kredensial Syrve.',
    'syrve.connectionDetail.card.status': 'Status',
    'syrve.connectionDetail.card.connection': 'Koneksi',
    'syrve.connectionDetail.card.diagnostics': 'Diagnostik',
    'syrve.connectionDetail.field.state': 'Keadaan',
    'syrve.connectionDetail.field.bridge': 'Bridge',
    'syrve.connectionDetail.field.lastCheck': 'Pemeriksaan terakhir',
    'syrve.connectionDetail.field.name': 'Nama',
    'syrve.connectionDetail.field.scope': 'Scope',
    'syrve.connectionDetail.field.scopeChain': 'CHAIN: koneksi level jaringan/organisasi',
    'syrve.connectionDetail.field.scopeRms': 'RMS: koneksi ke satu Outlet',
    'syrve.connectionDetail.field.baseUrl': 'Alamat server',
    'syrve.connectionDetail.field.login': 'Login',
    'syrve.connectionDetail.field.serverVersion': 'Versi server',
    'syrve.connectionDetail.field.serverEdition': 'Edisi server',
    'syrve.connectionDetail.diagnostics.show': 'Tampilkan detail teknis',
    'syrve.connectionDetail.diagnostics.payConnectionId': 'ID koneksi Pay',
    'syrve.connectionDetail.diagnostics.integrationLinkId': 'ID tautan integrasi',
    'syrve.connectionDetail.diagnostics.diagnosticCode': 'Kode diagnostik',
    'syrve.connectionDetail.diagnostics.authMode': 'Mode auth',
    'syrve.connectionDetail.diagnostics.sessionTransport': 'Transport sesi',
    'syrve.connectionDetail.diagnostics.credentialMode': 'Mode kredensial',
    'syrve.connectionDetail.diagnostics.runtime': 'Runtime Syrve',
    'syrve.connectionDetail.diagnostics.httpStatus': 'HTTP status pemeriksaan terakhir',
    'syrve.connectionDetail.diagnostics.iikoErrorCode': 'Kode error integrasi',
    'syrve.documents.title': 'Dokumen Syrve',
    'syrve.documents.subtitle': 'Salinan lokal status dokumen setelah sinkronisasi',
    'syrve.documents.tabs.all': 'Semua',
    'syrve.documents.tabs.unpaid': 'Belum dibayar',
    'syrve.documents.tabs.partiallyPaid': 'Dibayar sebagian',
    'syrve.documents.tabs.paid': 'Dibayar',
    'syrve.documents.typeTabs.all': 'Semua tipe',
    'syrve.documents.typeTabs.incoming': 'Masuk',
    'syrve.documents.typeTabs.outgoing': 'Keluar',
    'syrve.documents.type.incoming': 'Masuk',
    'syrve.documents.type.outgoing': 'Keluar',
    'syrve.documents.unpaid.title': 'Belum dibayar',
    'syrve.documents.unpaid.subtitle': 'Dokumen dengan saldo belum lunas',
    'syrve.documents.partiallyPaid.title': 'Dibayar sebagian',
    'syrve.documents.partiallyPaid.subtitle': 'Dokumen dengan pembayaran sebagian',
    'syrve.documents.paid.title': 'Dibayar',
    'syrve.documents.paid.subtitle': 'Dokumen lunas',
    'syrve.documents.sync': 'Sinkronkan',
    'syrve.documents.column.number': 'Nomor',
    'syrve.documents.column.counterparty': 'Counterparty',
    'syrve.documents.column.type': 'Tipe',
    'syrve.documents.column.unpaid': 'Belum dibayar',
    'syrve.documents.column.balance': 'Saldo',
    'syrve.documents.balance.outstanding': 'Harus dibayar',
    'syrve.documents.balance.paid': 'Dibayar',
    'syrve.documents.balance.overpaid': 'Kelebihan bayar',
    'syrve.documents.column.synced': 'Sync',
    'syrve.documents.column.processingState': 'Pemrosesan',
    'syrve.documents.processing.processed': 'Diproses',
    'syrve.documents.processing.notProcessed': 'Belum diproses',
    'syrve.documents.processing.unknown': 'Status tidak diketahui',
    'syrve.documents.processing.deleted': 'Dihapus',
    'syrve.documents.empty.title': 'Dokumen tidak ditemukan',
    'syrve.documents.empty.description': 'Jalankan sinkronisasi atau periksa koneksi Syrve.',
    'syrve.documentDetail.notFound': 'Dokumen tidak ditemukan',
    'syrve.documentDetail.title': 'Faktur #{number}',
    'syrve.documentDetail.refresh': 'Segarkan dari Syrve',
    'syrve.documentDetail.readOnlyBadge': 'Hanya baca',
    'syrve.documentDetail.sections.summary': 'Ringkasan faktur',
    'syrve.documentDetail.sections.amounts': 'Jumlah dan pembayaran',
    'syrve.documentDetail.documentStatus': 'Status dokumen',
    'syrve.documentDetail.paymentStatus': 'Status pembayaran',
    'syrve.documentDetail.linesCount': '{count} baris',
    'syrve.documentDetail.linesCountEmpty': 'Tidak ada baris',
    'syrve.documentDetail.counterparty': 'Counterparty',
    'syrve.documentDetail.supplier': 'Supplier',
    'syrve.documentDetail.buyer': 'Pembeli',
    'syrve.documentDetail.documentType': 'Tipe dokumen',
    'syrve.documentDetail.documentNumber': 'Nomor',
    'syrve.documentDetail.documentDate': 'Tanggal',
    'syrve.documentDetail.warehouse': 'Gudang',
    'syrve.documentDetail.conception': 'Konsep',
    'syrve.documentDetail.comment': 'Komentar',
    'syrve.documentDetail.paid': 'Dibayar',
    'syrve.documentDetail.unpaid': 'Belum dibayar',
    'syrve.documentDetail.outstanding': 'Harus dibayar',
    'syrve.documentDetail.overpayment': 'Kelebihan bayar',
    'syrve.documentDetail.lastSync': 'Sinkronisasi terakhir',
    'syrve.documentDetail.linesSyncedAt': 'Baris disinkronkan',
    'syrve.documentDetail.linesSection': 'Posisi barang',
    'syrve.documentDetail.payloadHash': 'Payload hash',
    'syrve.documentDetail.tabs.all': 'Semua',
    'syrve.documentDetail.tabs.goods': 'Barang',
    'syrve.documentDetail.tabs.goodsHint': 'Filter tipe item akan diperluas; saat ini semua baris ditampilkan.',
    'syrve.documentDetail.lines.num': 'No',
    'syrve.documentDetail.lines.productCode': 'Kode produk',
    'syrve.documentDetail.lines.productName': 'Nama',
    'syrve.documentDetail.lines.productSize': 'Ukuran',
    'syrve.documentDetail.lines.amountUnit': 'Satuan',
    'syrve.documentDetail.lines.amount': 'Jumlah',
    'syrve.documentDetail.lines.actualAmount': 'Aktual',
    'syrve.documentDetail.lines.price': 'Harga satuan',
    'syrve.documentDetail.lines.sumWithVat': 'Jumlah + PPN',
    'syrve.documentDetail.lines.discount': 'Diskon',
    'syrve.documentDetail.lines.ndsPercent': 'PPN %',
    'syrve.documentDetail.lines.ndsSum': 'PPN',
    'syrve.documentDetail.lines.sumWithoutNds': 'Tanpa PPN',
    'syrve.documentDetail.lines.amountFactor': 'Koef. write-off',
    'syrve.documentDetail.lines.costPrice': 'Harga pokok',
    'syrve.documentDetail.lines.stockBalance': 'Stok sebelum/sesudah',
    'syrve.documentDetail.lines.customsDeclaration': 'Deklarasi bea cukai',
    'syrve.documentDetail.lines.comment': 'Komentar',
    'syrve.documentDetail.lines.empty': 'Posisi belum dimuat. Segarkan dari Syrve atau jalankan sync dokumen.',
    'syrve.syncRuns.title': 'Riwayat sinkronisasi',
    'syrve.syncRuns.subtitle': 'SyrveDocumentSyncRun — audit sync berkala',
    'syrve.syncRuns.column.started': 'Mulai',
    'syrve.syncRuns.column.seen': 'Terlihat',
    'syrve.syncRuns.column.inserted': 'Baru',
    'syrve.syncRuns.column.updated': 'Diperbarui',
    'syrve.syncRuns.column.stale': 'Stale',
    'syrve.syncRuns.empty.title': 'Belum ada sinkronisasi',
    'syrve.postings.title': 'Antrean posting pembayaran',
    'syrve.postings.subtitle': 'Status pengiriman ke iiko/Syrve untuk setiap posting dan langkah berikutnya',
    'syrve.postings.loading': 'Memuat antrean posting…',
    'syrve.postings.filterStatus': 'Status: {status}',
    'syrve.postings.actions.refresh': 'Segarkan',
    'syrve.postings.filters.all': 'Semua',
    'syrve.postings.filters.approve': 'Menunggu persetujuan',
    'syrve.postings.filters.ready': 'Antrean worker',
    'syrve.postings.filters.inProgress': 'Sedang dikirim',
    'syrve.postings.filters.failed': 'Gagal',
    'syrve.postings.filters.done': 'Selesai',
    'syrve.postings.column.paymentId': 'ID posting',
    'syrve.postings.column.allocation': 'Alokasi',
    'syrve.postings.column.amount': 'Jumlah',
    'syrve.postings.column.postingStatus': 'Status posting',
    'syrve.postings.column.nextStep': 'Langkah berikutnya',
    'syrve.postings.column.action': 'Aksi',
    'syrve.postings.column.attempts': 'Percobaan iiko',
    'syrve.postings.action.open': 'Buka',
    'syrve.postings.action.approve': 'Setujui',
    'syrve.postings.action.retry': 'Coba lagi',
    'syrve.postings.actionHint.approve': 'Diperlukan persetujuan manual posting. Setelah itu worker mengirim pembayaran ke iiko.',
    'syrve.postings.actionHint.waitingWorker': 'Disetujui. Worker akan mengambilnya dalam ~30 detik.',
    'syrve.postings.actionHint.sending': 'Worker sedang mengirim pembayaran ke iiko.',
    'syrve.postings.actionHint.readback': 'Pembayaran terkirim. Menunggu readback dan rekonsiliasi.',
    'syrve.postings.actionHint.retryScheduled': 'Pengulangan dijadwalkan otomatis.',
    'syrve.postings.actionHint.failed': 'Pengiriman gagal. Anda bisa mencoba lagi secara manual.',
    'syrve.postings.actionHint.done': 'Posting selesai dan direkonsiliasi.',
    'syrve.postings.actionHint.posted': 'Pembayaran dicatat di iiko, menunggu rekonsiliasi final.',
    'syrve.postings.actionHint.open': 'Buka kartu posting untuk detail.',
    'syrve.postings.summary.total': 'Total posting',
    'syrve.postings.summary.approve': 'Menunggu persetujuan',
    'syrve.postings.summary.ready': 'Antrean worker',
    'syrve.postings.summary.done': 'Selesai',
    'syrve.postings.summary.pendingAmount': 'Jumlah belum selesai',
    'syrve.postings.empty.title': 'Antrean kosong',
    'syrve.postings.empty.description': 'Tidak ada posting pada filter yang dipilih',
    'syrve.reconciliation.title': 'Reconciliation — menunggu pemeriksaan pasca posting',
    'syrve.postingDetail.notFound': 'Posting tidak ditemukan',
    'syrve.postingDetail.title': 'Posting {id}…',
    'syrve.postingDetail.subtitle': 'Allocation {allocationId}',
    'syrve.postingDetail.dryRun': 'Dry-run',
    'syrve.postingDetail.approve': 'Setujui',
    'syrve.postingDetail.retryWrite': 'Ulangi write',
    'syrve.postingDetail.reconcile': 'Rekonsiliasi',
    'syrve.postingDetail.anomaly.title': 'Anomali pembayaran kritis',
    'syrve.postingDetail.anomaly.description': 'Pembayaran mungkin sudah diposting di Syrve, tetapi rekonsiliasi belum dikonfirmasi. Posting ulang diblokir hingga pemeriksaan manual.',
    'syrve.postingDetail.anomaly.link': 'Anomali {id}…',
    'syrve.postingDetail.writeBlocked': 'Posting ulang diblokir: ada anomali kritis terbuka pada dokumen.',
    'syrve.postingDetail.operationFailed': 'Operasi gagal. Segarkan posting: status atau rowVersion mungkin berubah.',
    'syrve.postingDetail.postedNotReconciled': 'Pembayaran diposting (PASS_WRITE), tetapi rekonsiliasi belum dikonfirmasi (Not PASS_RECONCILE).',
    'syrve.postingDetail.reconciled': 'PASS_WRITE + PASS_RECONCILE',
    'syrve.postingDetail.preflight.title': 'Method-specific preflight',
    'syrve.postingDetail.preflight.eligible': 'Eligible',
    'syrve.postingDetail.preflight.notEligible': 'Not eligible',
    'syrve.postingDetail.writeTarget.title': 'Write target and gates',
    'syrve.postingDetail.writeTarget.account': 'Account',
    'syrve.postingDetail.writeTarget.cashFlowArticle': 'Cash-flow article',
    'syrve.postingDetail.writeTarget.idempotencyKey': 'Idempotency key',
    'syrve.postingDetail.writeTarget.requestHash': 'Request hash',
    'syrve.postingDetail.writeTarget.attemptCount': 'Attempt count',
    'syrve.postingDetail.writeTarget.reconciliationAttempts': 'Reconciliation attempts',
    'syrve.postingDetail.writeTarget.nextRetry': 'Next retry',
    'syrve.postingDetail.writeTarget.nextReconciliation': 'Next reconciliation',
    'syrve.postingDetail.writeTarget.openAnomaly': 'Open anomaly',
    'syrve.postingDetail.writeTarget.rowVersion': 'RowVersion',
    'syrve.postingDetail.writeTarget.accountId': 'Account ID',
    'syrve.postingDetail.writeTarget.accountName': 'Account name',
    'syrve.postingDetail.writeTarget.cashFlowArticleId': 'Cash-flow article ID',
    'syrve.postingDetail.writeTarget.cashFlowArticleName': 'Cash-flow article name',
    'syrve.postingDetail.writeTarget.save': 'Simpan write target',
    'syrve.postingDetail.dryRun.title': 'Dry-run',
    'syrve.postingDetail.dryRun.allowed': 'Diizinkan (preview)',
    'syrve.postingDetail.dryRun.blocked': 'Diblokir: {reason}',
    'syrve.postingDetail.dryRun.unknown': 'unknown',
    'syrve.postingDetail.attempts.title': 'Worker attempts',
    'syrve.postingDetail.attempts.column.time': 'Waktu',
    'syrve.postingDetail.attempts.column.reason': 'Alasan',
    'syrve.postingDetail.attempts.empty.title': 'Belum ada percobaan worker',
    'syrve.postingDetail.attempts.empty.description': 'Percobaan muncul di sini setelah queue/approve.',
    'syrve.postingDetail.evidence.title': 'Laporan rekonsiliasi',
    'syrve.postingDetail.evidence.writeStatus': 'Status write',
    'syrve.postingDetail.evidence.writeDiagnostic': 'Write diagnostic',
    'syrve.postingDetail.evidence.writeMessage': 'Write message',
    'syrve.postingDetail.evidence.reconciliationStatus': 'Status reconciliation',
    'syrve.postingDetail.evidence.reconciliationDiagnostic': 'Reconciliation diagnostic',
    'syrve.postingDetail.evidence.reconciliationMessage': 'Reconciliation message',
    'syrve.postingDetail.evidence.expected.title': 'Status yang diharapkan (perhitungan lokal)',
    'syrve.postingDetail.evidence.expected.item': '{status}, unpaid {amount} (perhitungan lokal)',
    'syrve.postingDetail.evidence.live.title': 'Status Syrve aktual (live readback)',
    'syrve.postingDetail.evidence.live.source': 'Source',
    'syrve.postingDetail.evidence.live.item': '{status}, unpaid {amount}',
    'syrve.postingDetail.evidence.live.pending': 'Live readback belum dilakukan',
  },
} as const;
